import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyBun2tapS0GAbPspq4wLCzEvvTr74GfSqY",
  authDomain: "glaxmore-it.firebaseapp.com",
  projectId: "glaxmore-it",
  storageBucket: "glaxmore-it.firebasestorage.app",
  messagingSenderId: "168189751276",
  appId: "1:168189751276:web:48e1faf62fb771e1809ac9"
};


const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const storage = getStorage(app);

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };